import { toDisplayTitle } from './assetDisplay';
import {
  formatParticlePreviewPlainText,
  formatParticlePreviewTitle,
} from './particlePreviewText';
import { safeExtractText } from './textHelper';

function readPreviewCandidate(input: {
  title?: string;
  questions?: unknown;
  answers?: unknown;
  content?: unknown;
}): unknown {
  return input.title || input.questions || input.content || input.answers;
}

export function getParticlePreviewText(
  input: {
    title?: string;
    questions?: unknown;
    answers?: unknown;
    content?: unknown;
  },
  maxLength = 120,
): string {
  const formatted = formatParticlePreviewPlainText(readPreviewCandidate(input), maxLength);
  if (formatted) {
    return formatted;
  }

  return toDisplayTitle(input.title)
    || safeExtractText(input.questions)
    || safeExtractText(input.content)
    || safeExtractText(input.answers);
}

export function getParticleTitle(
  input: {
    title?: string;
    questions?: unknown;
    answers?: unknown;
    content?: unknown;
    id?: string;
  },
  maxLength = 80,
): string {
  const formatted = formatParticlePreviewTitle(readPreviewCandidate(input), maxLength);
  if (formatted) {
    return formatted;
  }

  return getParticlePreviewText(input, maxLength) || '未命名颗粒';
}

export function truncatePreview(text: string, maxLength = 120): string {
  const normalized = text.replace(/\s+/g, ' ').trim();
  if (normalized.length <= maxLength) {
    return normalized;
  }
  return `${normalized.slice(0, Math.max(maxLength - 1, 1)).trimEnd()}…`;
}
